<template>
	  <main>
		<p class="history-count">Showing the last 30 records.</p>
		<h5 class="mt-3 mb-3">eBay History</h5>
		<div class="history">
		  <div v-for="h in history">
			<div class="row">
				<div class="col-5">
				  <b>Status:</b>  {{h.status}}. <i v-if="h.status == 'running'" class="fas fa-cog fa-spin"></i><br/>
				  <b>Last log:</b>  {{h.status_update.split(',').slice(-1).pop()}}.
				</div>
				<div class="col-5">
				  <b>Started:</b>  {{$moment(h.created_at).calendar(null,{sameElse: 'lll'})}}.<br/>
				  <b v-if="h.status == 'running'">Last update:</b> <b v-else>Finished:</b> {{$moment(h.updated_at).calendar(null,{sameElse: 'lll'})}}.
				</div>
				<div class="col-2 text-center">
					<button class="btn btn-primary" 
					v-on:click.prevent="getlog(h.id)">Logs</button>
				</div>
		  </div>
	  </div>
	</div>
	<div v-if="plog.length || plog.emptylogs" class="plog">
		<div class="row">
			<div class="col-6">
			<h2>Logs</h2> 
			</div>
			<div class="col-6">
			<button v-on:click.prevent="closelog" class="btn btn-secondary pull-right">Close</button>
			</div>
		</div>
		<div v-if="plog.emptylogs && plognoitem.emptylogs" class="row">
			<div class="col-12"><p>No logs found for this script</p></div>
		</div>
		<div v-else>
			<div v-for="logitem in plog" class="row logitem">
				<div class="col-12" v-if="logitem.item">
					<div class="row">
					<div class="col-12 headline">
						<b>{{logitem.item.title}}</b>
						<a class="btn btn-sm btn-1 mx-1" :href="`http://cgi.ebay.com/ws/eBayISAPI.dll?ViewItem&item=${logitem.platform_id}`"  target="_blank">eBay</a>
						<a class="btn btn-sm btn-1 mx-1" :href="`http://k2b-bulk.ebay.com/ws/eBayISAPI.dll?MfcISAPICommand=ListingConsole&currentpage=LCActive&pageNumber=1&searchField=ItemId&searchValues=${logitem.platform_id}&StoreCategory=-4&Status=All&Format=All&matchCriteria=and&srcFld_1=Title&searchOpDd_1=CONTAINS&srcVal_1=&lrowcount=1&srcType=0&searchSubmit=Search&goToPage=`" target="_blank">eBay Manage</a>
					</div>
					</div>
					<div v-for="meta in logitem.platform_meta" class="row meta">
						<div class="col-6">
							{{meta.title}}
						</div>
						<div class="col-6">{{meta.message}}</div>
					</div>
				</div>
			</div>
			<div v-for="logitem in plognoitem" class="row logitem">
				<div class="col-12">
					<div class="row meta">
						<div class="col-6">
							{{logitem.title}}
						</div>
						<div class="col-6">{{logitem.message}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
  </main>
</template>
	
	<script>
	export default {
		name: 'Ebay',
		data: function() {
			return {
				history: [],
				plog: [],
				plognoitem: []
			};
		},
		methods: {
			refresh: function() {
				this.$axios.get(`/script/ebay`)
					.then((response) => {
						// console.log(response.data.data);
	
						this.history = response.data.data;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						//
					});
			},
			getlog: function( scriptId ) {
				var that = this;
				that.$Progress.start();

				this.$axios.get(`/platform/${scriptId}/log`)
					.then((response) => {
						console.log(response);
						
						if( response.data.length > 0)
							this.plog = response.data;
						else
							this.plog = {emptylogs: true};
						
						console.log(this.plog)	
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						that.$Progress.finish();
					});
				
				this.$axios.get(`/platform/${scriptId}/lognoitem`)
				.then((response) => {
					console.log(response);
					
					if( response.data.length > 0)
						this.plognoitem = response.data;
					else
						this.plognoitem = {emptylogs: true};
					
					console.log(this.plognoitem)	
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					that.$Progress.finish();
				});	
			},
			closelog: function(){
				this.plog = [];
			}
		},
		mounted: function() {
			this.refresh();
			setInterval(() => {
				this.refresh();
			}, 3000);
		},
	};
	</script>
	
	<style scoped lang="less">
	.history {
	  margin-left: -15px;
	}
	.history > div{
	  border-top: 1px solid #efefef;
	  padding: 15px;
	}
	.history-count{
	  position: absolute;
	  right: 30px;
	  margin: 0;
	}
	.plog{
		.headline{
			background: #efefef;
			padding: 5px;
		}
		
		padding: 30px;
		background:#fff;
		position: fixed;
		top:0;
		left: 0;
		width:100%;
		height: 100%;
		z-index: 20;
		overflow-y: scroll;
		
		.logitem{
			padding: 0;
			margin: 20px 0 0 0;
			border-top:1px solid #efefef;
			border-left: 4px solid #efefef;
			border-right: 4px solid #efefef;

			.meta{
				padding-left: 20px;
				border-bottom: 1px solid #efefef;

			}
		}
	}
	
	
	</style>
	